import { render, staticRenderFns } from "./CommercialProperty.vue?vue&type=template&id=25c6df6f&scoped=true&"
import script from "./CommercialProperty.vue?vue&type=script&lang=js&"
export * from "./CommercialProperty.vue?vue&type=script&lang=js&"
import style0 from "./CommercialProperty.vue?vue&type=style&index=0&id=25c6df6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6df6f",
  null
  
)

export default component.exports